import { Modal } from 'bootstrap';

    const representationModal = '<div id="Representation_modal" class="modal fade" tabindex="-1" role="dialog">' +
                                '<div class="modal-dialog modal-lg">' +
                                    '<div class="modal-content">' +
                                        '<div class="modal-header">' +
                                            '<h4 class="modal-title">Représentation des indices par école</h4>' +
                                            '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>' +
                                        '</div>' +
                                        '<div class="modal-body">' +
                                            '<img class="text-nowrap" style="width:100%" src="documents/Representation_ecole_v2.png" class="img-fluid" alt="...">' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>';

    export default class Representation {
        constructor() {
            this._$representationModal = $(representationModal);
            $("body").append(this._$representationModal);
            new Modal('#Representation_modal');
        };
    };